import { type MetaDataTable } from "./element";

/**
 * Helper function to assist IDE with completion and type-checking.
 *
 * @public
 */
export function defineMetadata(metatable: MetaDataTable): MetaDataTable {
	return metatable;
}
